import React, { ReactElement, FunctionComponent } from 'react';
import { Modal, Button } from 'react-bootstrap';

// Components
import Separator from '../../../Separator/Separator';

// Types and constants
import { FirmwareModel } from '../../../../shared/types';

export type DeleteFirmwareDialogProps = {
    openDeleteFirmwareDialog: boolean;
    firmwaresToDelete: FirmwareModel[];
    handleClose: () => void;
    deleteFirmware: () => void;
}

const DeleteFirmwareDialog: FunctionComponent<DeleteFirmwareDialogProps> = (props: DeleteFirmwareDialogProps): ReactElement => {
    const {
        openDeleteFirmwareDialog,
        firmwaresToDelete,
        handleClose,
        deleteFirmware,
    } = props;

    return (
        <div data-testid='delete-firmware-dialog-container'>
            <Modal
                show={openDeleteFirmwareDialog}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Firmware</Modal.Title>
                </Modal.Header>
                <Separator />
                <Modal.Body>
                    Are you sure you want to delete a firmware for the component:
                    {
                        firmwaresToDelete.map((firmware) => (
                            <>, <b> {firmware.name} </b></>
                        ))
                    }
                    ?
                </Modal.Body>
                <Separator />
                <Modal.Footer>
                    <Button variant="outline-danger" onClick={deleteFirmware} data-testid='confirm-delete-firmware'>
                        Yes
                    </Button>
                    <Button variant="outline-dark" onClick={handleClose}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DeleteFirmwareDialog;
